import posthog from "posthog-js"
import * as m from "@/paraglide/messages"
import updateArrows from "@/shared/assets/icons/update-arrows.webp"
import { openAppStore } from "@/shared/lib/app-update/plugin"
import { detectStore } from "@/shared/lib/platform"
import { SecondaryButton } from "@/shared/ui/secondary-button"

export function UpdateRequiredScreen() {
	const store = detectStore()

	const handleUpdate = async () => {
		if (store === null) {
			window.location.reload()
			return
		}
		try {
			await openAppStore()
		} catch (error) {
			posthog.captureException(error, { scope: "updateRequired.openStore" })
		}
	}

	let buttonLabel = m.updateRequiredBtnUpdate()
	if (store === null) {
		buttonLabel = m.updateRequiredBtnReload()
	}

	return (
		<div className="fixed inset-0 z-50 flex overflow-y-auto bg-white p-dialog-safe [--u:calc(var(--viewport-dynamic-height)/100)]">
			<div className="m-auto flex w-full max-w-[390px] flex-col items-center gap-[clamp(16px,calc(var(--u)*3.8),32px)] px-6">
				<div className="flex items-center rounded-[64px] bg-[linear-gradient(57deg,#d7d3fb_10%,#eee9ed_31%,#cfdaeb_51%,#c7ebed_72%,#cce0f2_93%)] p-[clamp(12px,calc(var(--u)*2.4),20px)]">
					<img
						src={updateArrows}
						alt=""
						className="size-[clamp(56px,calc(var(--u)*10.4),88px)]"
					/>
				</div>

				<div className="flex w-full flex-col gap-[clamp(8px,calc(var(--u)*1.9),16px)] text-center">
					<h1 className="leading-[1.25] font-bold text-[#373b47] text-[length:clamp(24px,calc(var(--u)*3.8),32px)]">
						{m.updateRequiredTitle()}
					</h1>
					<p className="text-base leading-5 font-semibold text-[#5d6479]">
						{m.updateRequiredDescription()}
					</p>
				</div>

				<SecondaryButton
					type="button"
					onClick={() => void handleUpdate()}
					className="h-[clamp(48px,calc(var(--u)*7.6),64px)]"
				>
					{buttonLabel}
				</SecondaryButton>
			</div>
		</div>
	)
}
